import { useState } from 'react'
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Stack,
  Button,
  Image,
  Input,
  Box,
  useDisclosure
} from '@chakra-ui/react'
import DatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'

import ReturnDrawerMobile from './ReturnDrawerMobile'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('es', es)
const quilmesImages = require.context('../assets/images', true)

const DateDrawer = ({ survey, setSurvey, sizes }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [size, setSize] = useState('')
  /**
   * It takes a newSize as an argument, sets the size to the newSize, and then calls the onOpen
   * function
   * @param newSize - The new size of the modal.
   */
  const handleClick = (newSize) => {
    setSize(newSize)
    onOpen()
  }

  const { date } = survey

  /**
   * It takes a date as an argument, and then sets the survey state to the current survey state, but
   * with the date property set to the date argument
   * @param date - The date that the user has selected.
   */
  const handleChangeDate = (date) => {
    setSurvey({ ...survey, date })
  }

  return (
    <>
      <Stack>
        <Button
          key={size}
          display={'flex'}
          fontWeight={500}
          justifyContent={'space-between'}
          variant='outline'
          onClick={() => handleClick(sizes)}
        >
          <input
            readOnly
            className='input-date-mobile'
            type='text'
            value={date === '' ? 'Fecha *' : date.toLocaleDateString('es-ES')}
          />

          <Image src={quilmesImages('./Vector.svg')} width={'12px'} />
        </Button>
      </Stack>
      <Drawer isOpen={isOpen} size={sizes} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <ReturnDrawerMobile onClose={onClose} />
          <DrawerBody paddingTop={6}>
            <Box paddingTop={'1rem'}>
              <DatePicker
                inline
                customInput={<Input />}
                dateFormat='dd/MM/yyyy'
                dateFormatCalendar='MMMM'
                locale='es'
                maxDate={new Date()}
                selected={date}
                value={date}
                onChange={handleChangeDate}
              />
            </Box>
            <Box
              alignItems={'center'}
              display={'flex'}
              justifyContent={'center'}
              paddingTop={'5rem'}
            >
              <Button variant={'btn-quilmes'} w={'100%'} onClick={onClose}>
                Seleccionar
              </Button>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default DateDrawer
